import { dialog } from "../../../../../nq-component";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";
import DialogModal from "../../../../../components/Dialog";
import { auditLogUseCase } from "../../../../../usecases/logs";
import { findObjectUseCase } from "../../../../../usecases/object";
import ErrorModal from "../../../../../components/ErrorModal";

class UpcomingRequestFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;

    if (!this.object.raw_materials && this.view.state.object?.raw_materials) {
      this.object.raw_materials = [...this.view.state.object.raw_materials];
    }

    this.view.setObject(this.object);
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = {
        include: [
          "raw_materials",
          "raw_materials.uom",
          "uom",
          "sourceLocation",
          "destinationLocation",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  generateRequestNumber(prefix = "ANGELSPIZZA") {
    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const yyyy = now.getFullYear();
    const randomDigits = Math.floor(1000 + Math.random() * 9000);

    return `${prefix}-${mm}${dd}${yyyy}-${randomDigits}`;
  }

  generateTransferNumber() {
    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const yyyy = now.getFullYear();
    const randomDigits = Math.floor(1000 + Math.random() * 9000);

    return `TRANSFER-${mm}${dd}${yyyy}-${randomDigits}`;
  }

  async approveReco() {
    try {
      const user = this.view.getCurrentUser();
      const collection = this.view.getCollectionName();
      const now = new Date();
      const currentTimestamp = now.toISOString();

      const object = this.view.state.object;
      const sourceLocation = object?.destinationLocation?.id;

      console.log("object", object);

      const updatePayload = {
        id: object.id,
        status: "Partially Received",
      };

      console.log("object", updatePayload);

      for (const item of object?.items) {
        const [senderInventory] = await findObjectUseCase().execute(
          "inventory",
          {
            where: {
              sku: item.sku,
              "storeId.id": sourceLocation,
            },
            limit: 1,
          },
        );

        console.log("senderInventory", senderInventory);

        if (senderInventory) {
          const updatedRequestorQty = Math.max(
            parseFloat(senderInventory.systemCount || 0) +
              parseFloat(item.quantityReceive),
            0,
          );

          console.log("updatedSenderQty", updatedRequestorQty);

          const difference =
            parseFloat(senderInventory.systemCount || 0) - updatedRequestorQty;

          console.log("diffd", difference);

          const existingTransferCount = Array.isArray(
            senderInventory?.transferCount,
          )
            ? senderInventory.transferCount
            : [];

          const newTransferCount = {
            sku: senderInventory?.sku,
            difference: difference,
            sourceLocation: object?.sourceLocation,
            destinationLocation: object?.destinationLocation,
          };

          const transferCountArray = [
            ...existingTransferCount,
            newTransferCount,
          ];

          console.log("transferCountArray", transferCountArray);

          await this.upsertUseCase.execute("inventory", {
            id: senderInventory.id,
            systemCount: String(updatedRequestorQty),
            transferCount: transferCountArray,
          });

          await this._saveReceivableTransaction({
            storeId: { id: sourceLocation },
            sku: item.sku,
            item_name: item?.itemName,
            transaction_type: "Transfer Out",
            quantity: String(-item.quantityReceive),
            business_date: new Date().toISOString(),
            reference_id: object?.id,
          });

          await auditLogUseCase().create({
            user: { id: user.id },
            logDate: currentTimestamp,
            message: `Deducted ${item.quantityApprove} of ${item.itemName} from sender store.`,
            collection: "inventory",
            objectId: senderInventory.id,
            payload: {
              beforeUpdate: senderInventory,
              updatedQty: updatedRequestorQty,
            },
            store: { id: senderInventory?.storeId.id },
          });
        }
      }

      const result = await this.upsertUseCase.execute(
        collection,
        updatePayload,
      );

      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Pending Fully Received stock request ${object.requestNumber}" (s)`,
        collection,
        objectId: object.id,
        payload: {
          request: object,
          response: updatePayload,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });

      const findTransfer = await findObjectUseCase().execute(
        "stock_transfers",
        {
          where: { linkedRequestId: object.id },
        },
      );
      console.log("findtrans", findTransfer);

      const existingTransfer = findTransfer[0];

      if (existingTransfer) {
        // 📦 Update the status and append to logsArray
        const existingLogs = existingTransfer.logsArray || [];

        const newLog = {
          status: "Partially Received",
          timestamp: currentTimestamp,
          updatedBy: {
            id: user.id,
            name: user.username || user.email,
          },
          remarks: object?.remarks,
        };
        const updatedLogs = [...existingLogs, newLog];
        const updatedTransfer = {
          id: existingTransfer.id,
          status: "Partially Received",
          logsArray: updatedLogs,
        };

        console.log("Update", updatedTransfer);

        await this.upsertUseCase.execute("stock_transfers", updatedTransfer);

        // 📝 Optional: Audit log for transfer update
        await auditLogUseCase().create({
          user: { id: user.id },
          logDate: currentTimestamp,
          message: `Updated stock transfer ${existingTransfer.transferNumber} to Pending Fully Received`,
          collection: "stock_transfers",
          objectId: existingTransfer.id,
          payload: {
            transfer: existingTransfer,
            update: updatedTransfer,
          },
          store: { id: user.storeAnalytic?.[0]?.id },
        });
      }

      // this.getObjects();
      dialog.close();
      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      throw error;
    }
  }

  // async save() {
  //   this.view.showProgressDialog();
  //   const collection = this.view.getCollectionName();
  //   const user = this.view.getCurrentUser();

  //   if (this.object.id) {
  //     this.change.id = this.object.id;
  //   } else {
  //     this.change.acl = this.view.getAcl();
  //   }

  //   const rawMaterials = computePartialCosts(
  //     this.view.state.object.raw_materials || []
  //   );
  //   this.change.raw_materials = rawMaterials;

  //   const now = new Date();
  //   const currentTimestamp = now.toISOString();
  //   this.change.requestDate = now.toISOString();
  //   this.change.requestNumber = this.generateRequestNumber();
  //   this.change.status = "Pending";
  //   this.change.requestedBy = { id: user.id };
  //   this.change.sourceLocation = { id: this.change.sourceLocation.id };
  //   this.change.destinationLocation = { id: user.storeAnalytic[0]?.id };
  //   this.change.items = this.change.raw_materials;
  //   this.change.storeId = { id: user.storeAnalytic[0]?.id };
  //   delete this.change.raw_materials;

  //   try {
  //     const result = await this.upsertUseCase.execute(collection, this.change);

  //     await auditLogUseCase().create({
  //       user: { id: user.id },
  //       logDate: currentTimestamp,
  //       message: `Created stock request ${this.change.requestNumber} with ${this.change.items.length} item(s)`,
  //       collection,
  //       objectId: result.id,
  //       payload: {
  //         request: this.change,
  //         response: result,
  //       },
  //       store: { id: user.storeAnalytic?.[0]?.id },
  //     });

  //     const transfer = {
  //       transferNumber: this.generateTransferNumber(),
  //       linkedRequestId: result.id,
  //       transferDate: now.toISOString(),
  //       requestDate: this.change.requestDate,
  //       // approvedDate: null, // will be updated later
  //       transferredBy: { id: user.id },
  //       sourceLocation: this.change.sourceLocation,
  //       destinationLocation: this.change.destinationLocation,
  //       items: this.change.items,
  //       remarks: this.change.remarks || "",
  //       logsArray: [
  //         {
  //           status: "Pending",
  //           timestamp: currentTimestamp,
  //           updatedBy: {
  //             id: user.id,
  //             name: user.username || user.email,
  //           },
  //           remarks: "Transfer record created",
  //         },
  //       ],
  //       status: "Pending",
  //       storeId: { id: user.storeAnalytic[0]?.id },
  //     };

  //     const responseTransfer = await this.upsertUseCase.execute(
  //       "stock_transfers",
  //       transfer
  //     );

  //     await auditLogUseCase().create({
  //       user: { id: user.id },
  //       logDate: currentTimestamp,
  //       message: `Created stock transfer ${transfer.transferNumber} linked to request ${this.change.requestNumber}`,
  //       collection: "stock_transfers",
  //       objectId: responseTransfer.id,
  //       payload: {
  //         transfer,
  //         response: responseTransfer,
  //       },
  //       store: { id: user.storeAnalytic?.[0]?.id },
  //     });
  //     this.change = {};
  //     this.view.hideProgressDialog();
  //   } catch (error) {
  //     throw error;
  //   }
  // }

  async save(index, reason) {
    try {
      const user = this.view.getCurrentUser();
      const collection = this.view.getCollectionName();
      const now = new Date();
      const currentTimestamp = now.toISOString();
      const object = this.view.state.object;
      const sourceLocation = object?.sourceLocation?.id;

      console.log("Object", object);

      const updatePayload = {
        id: object.id,
        items: object?.items,
        status: "Approved",
      };

      console.log("updatePayload", updatePayload);

      for (const item of object?.items) {
        const [senderInventory] = await findObjectUseCase().execute(
          "inventory",
          {
            where: {
              sku: item.sku,
              "storeId.id": sourceLocation,
            },
            limit: 1,
          },
        );

        console.log("senderInventory", senderInventory);

        if (senderInventory) {
          const updatedSenderQty = Math.max(
            parseFloat(senderInventory.systemCount || 0) - item.quantityApprove,
            0,
          );

          console.log("updatedSenderQty", updatedSenderQty);

          const difference =
            parseFloat(senderInventory.systemCount || 0) - updatedSenderQty;

          console.log("diffd", difference);

          const existingTransferCount = Array.isArray(
            senderInventory?.transferCount,
          )
            ? senderInventory.transferCount
            : [];

          const newTransferCount = {
            sku: senderInventory?.sku,
            difference: difference,
            sourceLocation: object?.sourceLocation,
            destinationLocation: object?.destinationLocation,
          };

          const transferCountArray = [
            ...existingTransferCount,
            newTransferCount,
          ];

          console.log("transferCountArray", transferCountArray);

          await this.upsertUseCase.execute("inventory", {
            id: senderInventory.id,
            systemCount: String(updatedSenderQty),
            transferCount: transferCountArray,
          });

          await this._saveReceivableTransaction({
            storeId: { id: sourceLocation },
            sku: item.sku,
            item_name: item?.itemName,
            transaction_type: "Transfer Out",
            quantity: String(-item.quantityApprove),
            business_date: new Date().toISOString(),
            reference_id: object?.id,
          });

          await auditLogUseCase().create({
            user: { id: user.id },
            logDate: currentTimestamp,
            message: `Deducted ${item.quantityApprove} of ${item.itemName} from sender store.`,
            collection: "inventory",
            objectId: senderInventory.id,
            payload: {
              beforeUpdate: senderInventory,
              updatedQty: updatedSenderQty,
            },
            store: { id: senderInventory?.storeId.id },
          });
        }
      }

      const result = await this.upsertUseCase.execute(
        collection,
        updatePayload,
      );

      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Approve stock request ${object.requestNumber} " (s)`,
        collection,
        objectId: object.id,
        payload: {
          request: result,
          response: updatePayload,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });

      const findTransfer = await findObjectUseCase().execute(
        "stock_transfers",
        {
          where: { linkedRequestId: object.id },
        },
      );

      const existingTransfer = findTransfer[0];

      if (existingTransfer) {
        const existingLogs = existingTransfer.logsArray || [];

        const newLog = {
          status: "Approved",
          timestamp: currentTimestamp,
          updatedBy: {
            id: user.id,
            name: user.username || user.email,
          },
          remarks: reason,
        };
        const updatedLogs = [...existingLogs, newLog];
        const updatedTransfer = {
          id: existingTransfer.id,
          status: "Approved",
          logsArray: updatedLogs,
        };

        await this.upsertUseCase.execute("stock_transfers", updatedTransfer);

        await auditLogUseCase().create({
          user: { id: user.id },
          logDate: currentTimestamp,
          message: `Updated stock transfer ${existingTransfer.transferNumber} to Approved`,
          collection: "stock_transfers",
          objectId: existingTransfer.id,
          payload: {
            transfer: existingTransfer,
            update: updatedTransfer,
          },
          store: { id: user.storeAnalytic?.[0]?.id },
        });
      }

      // this.getObjects();
      dialog.close();
      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              this.view.navigateBack();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      throw error;
    }
  }

  async _saveReceivableTransaction(inventoryItem) {
    try {
      // const payload = {
      //   storeId: { id: storeId },
      //   sku: material.sku,
      //   item_name: material.itemName,
      //   transaction_type: "Direct Purchase",
      //   quantity: String(material.quantity),
      //   business_date: new Date().toISOString(),
      //   reference_id: directPurchaseResponse?.id,
      // };

      await this.upsertUseCase.execute("inventory_transaction", inventoryItem);
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    try {
      this.view.submitting();
      dialog.close();
      await this.save();
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }

  async validateStocks(object) {
    const validationErrors = [];
    const validationErrors2 = [];
    const validationWarnings = [];

    for (const item of object.items) {
      if (
        !item.quantityApprove ||
        item.quantityApprove === "" ||
        parseFloat(item.quantityApprove) <= 0
      ) {
        validationErrors.push({
          itemName: item.itemName || item.name,
          sku: item.sku,
          message: "Quantity approve is required and must be greater than 0",
        });
        continue;
      }
      // if (
      //   !item.quantityApprove ||
      //   item.quantityApprove === "" ||
      //   parseFloat(item.quantityApprove) > item.quantity
      // ) {
      //   validationErrors.push({
      //     itemName: item.itemName || item.name,
      //     sku: item.sku,
      //     message:
      //       "The approved quantity cannot be greater than the available quantity and must be equal to or less than it.",
      //   });
      //   continue;
      // }

      const query = {
        where: {
          sku: item.sku,
          "storeId.id": object?.sourceLocation.id,
        },
        limit: 1,
      };

      const response = await findObjectUseCase().execute("inventory", query);

      if (!response || response.length === 0) {
        validationErrors.push({
          itemName: item.itemName || item.name,
          sku: item.sku,
          message: "Item not found in inventory",
          currentStock: 0,
          requestedQty: parseFloat(item.quantityApprove),
        });
        continue;
      }

      const inventoryItem = response[0];
      const systemCount = parseFloat(inventoryItem.systemCount) || 0;
      const quantityApprove = parseFloat(item.quantityApprove) || 0;

      if (quantityApprove > systemCount) {
        validationErrors.push({
          itemName: item.itemName || item.name,
          sku: item.sku,
          message: "Insufficient stock",
          currentStock: systemCount,
          requestedQty: quantityApprove,
          shortage: quantityApprove - systemCount,
        });
      } else if (quantityApprove === systemCount) {
        validationWarnings.push({
          itemName: item.itemName || item.name,
          sku: item.sku,
          message: "This will deplete the entire stock",
          currentStock: systemCount,
          requestedQty: quantityApprove,
        });
      } else if (quantityApprove > item?.quantity) {
        validationErrors2.push({
          itemName: item.itemName || item.name,
          sku: item.sku,
          message:
            "The approved quantity cannot be greater than the available quantity and must be equal to or less than it.",
          quantity: item?.quantity,
          quantityApprove: quantityApprove,
        });
      }
    }

    if (validationErrors.length > 0) {
      const errorMessage = validationErrors
        .map((err) => {
          if (err.currentStock !== undefined) {
            return `• ${err.itemName} (SKU: ${err.sku})\n  ${err.message}\n  Available: ${err.currentStock}, Requested: ${err.requestedQty}${err.shortage ? `, Short by: ${err.shortage}` : ""}`;
          }
          return `• ${err.itemName} (SKU: ${err.sku})\n  ${err.message}`;
        })
        .join("\n\n");

      const error = new Error(`Stock Validation Failed:\n\n${errorMessage}`);
      error.validationErrors = validationErrors;
      error.validationType = "error";
      throw error;
    }

    if (validationErrors2.length > 0) {
      const errorMessage = validationErrors2
        .map((err) => {
          if (err.currentStock !== undefined) {
            return `• ${err.itemName} (SKU: ${err.sku})\n  ${err.message}\n  Available: ${err.currentStock}, Requested: ${err.requestedQty}${err.shortage ? `, Short by: ${err.shortage}` : ""}`;
          }
          return `• ${err.itemName} (SKU: ${err.sku})\n  ${err.message}`;
        })
        .join("\n\n");

      const error = new Error(`Stock Validation Failed:\n\n${errorMessage}`);
      error.validationErrors = validationErrors;
      error.validationType = "error2";
      throw error;
    }

    if (validationWarnings.length > 0) {
      const warningMessage = validationWarnings
        .map(
          (warn) =>
            `• ${warn.itemName} (SKU: ${warn.sku})\n  ${warn.message}\n  Current Stock: ${warn.currentStock}, Requested: ${warn.requestedQty}\n  ⚠️ Remaining stock after approval: 0`,
        )
        .join("\n\n");

      const error = new Error(`Stock Depletion Alert:\n\n${warningMessage}`);
      error.validationErrors = validationWarnings.map((w) => ({
        ...w,
        remainingStock: 0,
      }));
      error.validationType = "warning";
      throw error;
    }

    return {
      isValid: true,
      warnings: validationWarnings,
      message: "Stock validation passed",
    };
  }

  async onSubmitForm() {
    const object = this.view.state.object;

    try {
      await this.validateStocks(object);

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Approve Request"
            message="Are you sure want to approve this request?"
            isCancelButton={true}
            onSubmit={() => this.submit()}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      const errors = error.validationErrors2 || [
        { itemName: "Errors", message: error.message },
      ];
      const type = error.validationType || "error";
      dialog.fire({
        html: (
          <ErrorModal
            title={
              type === "error"
                ? "Stock Validation Failed"
                : type === "error2"
                  ? "Stock Validation Failed"
                  : "Stock Depletion Alert"
            }
            errors={errors}
            type={type}
            onClose={() => dialog.close()}
            onConfirm={() => this.submit()}
          />
        ),
        footer: false,
      });
    }
  }
}

export default UpcomingRequestFormPresenter;
